module.exports = __webpack_public_path__ + "img/ic_close_white.7ddb6fbb.svg";